import { useEffect, useRef, useState } from "react";

const Visualizersm = ({ disabled }) => {
  const canvasRef = useRef(null);
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const dataArrayRef = useRef(null);
  const [hasMicPermission, setHasMicPermission] = useState(true); // true initially

  useEffect(() => {
    const startAudio = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
        const source = audioContextRef.current.createMediaStreamSource(stream);
        analyserRef.current = audioContextRef.current.createAnalyser();
        analyserRef.current.fftSize = 32;
        dataArrayRef.current = new Uint8Array(analyserRef.current.frequencyBinCount);
        source.connect(analyserRef.current);
        draw();
      } catch (err) {
        console.error("Microphone access denied:", err);
        setHasMicPermission(false); // Denied mic access
      }
    };

    const draw = () => {
      if (!canvasRef.current || !analyserRef.current) return;
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      const { width, height } = canvas;
      ctx.clearRect(0, 0, width, height);

      analyserRef.current.getByteFrequencyData(dataArrayRef.current);
      const barWidth = width / dataArrayRef.current.length;

      ctx.fillStyle = "#4B5563";
      dataArrayRef.current.forEach((value, i) => {
        const barHeight = (value / 445) * height;
        ctx.fillRect(i * barWidth, height - barHeight, barWidth - 2, barHeight);
      });

      requestAnimationFrame(draw);
    };

    startAudio();
  }, []);

  if (!hasMicPermission) return null;

  return (
    <canvas
      ref={canvasRef}
      width={150}
      height={40}
      className="transition-all duration-300"
    />
  );
};

export default Visualizersm;
